import { render, staticRenderFns } from "./AddPublicityDialog.vue?vue&type=template&id=13f2e0d2&scoped=true"
import script from "./AddPublicityDialog.vue?vue&type=script&lang=js"
export * from "./AddPublicityDialog.vue?vue&type=script&lang=js"
import style0 from "./AddPublicityDialog.vue?vue&type=style&index=0&id=13f2e0d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f2e0d2",
  null
  
)

export default component.exports